/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInterestDto } from '../models/CreateInterestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InterestsService {

    /**
     * @returns CreateInterestDto
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: CreateInterestDto,
    }): CancelablePromise<CreateInterestDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/interests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
